import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    width: ${displayState?.size ?? '12px'};
    height: ${displayState?.size ?? '12px'};;
    border-radius: 50%;
    background: ${displayState?.color};
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })